module.exports = __webpack_public_path__ + "img/financier.8abf71ea.png";